import React, { useReducer } from 'react'

import { userControlledFieldInitialState } from './store/State'

import userControlledFieldReducer from './store/Reducer'

import UserControlledFieldService from './Service'

const userControlledFieldContext = {
  state: userControlledFieldInitialState,
  handlers: {
    onAction: () => new Promise<void>(() => {})
  }
}

export type UserControlledFieldContext = typeof userControlledFieldContext

export const UserControlledFieldContextProvider = React.createContext<UserControlledFieldContext>(
  userControlledFieldContext
)

const Provider: React.FC = ({ children }) => {
  const [state] = useReducer(userControlledFieldReducer, userControlledFieldInitialState)

  const handlers = {
    onAction: UserControlledFieldService.onAction()
  }

  const contextValue = {
    ...userControlledFieldContext,
    state,
    handlers
  }

  return (
    <UserControlledFieldContextProvider.Provider value={contextValue}>
      {children}
    </UserControlledFieldContextProvider.Provider>
  )
}

export default Provider
